export default __webpack_public_path__ + "static/media/caltra.0c442b52.png";